import { styled } from 'libs/ui/styled';

export const ContentStyled = styled('div')(() => ({
  padding: '0 30px',
}));
